'use strict';

import { view } from '@/functions';

const prefix = '/acquirers';

export default [
    {
        path: prefix,
        name: 'acquirers',
        meta: {
            title: 'Acquirers',
            scopes: ['read_acquirers', 'write_acquirers'],
        },
        component: () => view('acquirers/index'),
    },
];
